import {useGetUnregisteredWorkersQuery} from "./people_api";
import React, {Fragment, ReactElement} from "react";
import useDownloadImage from "../storage/useDownloadImage";
import {
    Alert,
    Box,
    Card,
    CardContent,
    CardMedia,
    CircularProgress,
    Pagination,
    Toolbar,
    Typography
} from "@mui/material";
import userPlaceholder from "/assets/imgs/user.jpg";
import {ListCardDataCol, ListGrid} from "../../components/styled";

import usePaginator from "../../hooks/usePaginator";
import SnackError from "../../components/SnackError";
import filterFunction from "../../libs/filterFunction";
import sortComparator from "../../libs/sortComparator";
import pager from "../../libs/pager";
import {SearchBox} from "../../components/SearchBox";
import SortBox from "../../components/SortBox";
import {Tables} from "../../apitypes";

type PersonItemProps = {
    onDelete?: (id: number) => void,
    item: Tables<"unregistered_workers">
    onSelect?: (id: number) => void;

}


const PersonItem = (props: PersonItemProps) => {
    const {item, onSelect} = props;


    const avatarUrl = useDownloadImage("avatars", item.avatar_url)

    if (!item) {
        return <Box>
            <Alert severity={"error"}>Object not found!</Alert>
        </Box>
    }

    return <Card onClick={() => {
        onSelect && onSelect(item.id!);
    }} sx={{
        display: "flex"
    }}>
        <CardMedia component="img"
                   sx={{width: 120, height: 120, minWidth: 120, objectFit: "cover"}}
                   image={avatarUrl || userPlaceholder}
                   alt={item.lastName + " " + item.firstName}
        />
        <ListCardDataCol>
            <CardContent sx={{width: "100%"}}>
                <Typography variant={"h6"}>{item.lastName} {item.firstName}</Typography>
                <Typography variant={"body1"}>{item.partnerCode}</Typography>
            </CardContent>
        </ListCardDataCol>
    </Card>
}


type PersonListProps = {
    list: Tables<"unregistered_workers">[],

    onSelect?: (id: number) => void;
}

export const PersonList = (props: PersonListProps) => {
    const {list, onSelect} = props;

    return <ListGrid>

        {list.map(param => <PersonItem
                key={param.id}
                item={param}
                onSelect={onSelect}
            />
        )}
    </ListGrid>
}


type PersonControllerProps = {
    pageSize?: number;
    selectable?: boolean;
    onSelect?: (id: number) => void;
    customFilter?: ReactElement
}

const sortFields = {
    lastName: "Priimek",
    partnerCode: "Koda",
}
export const UnregisteredListController = function ({ onSelect}: PersonControllerProps) {

    const {
        filter,
        setFilter,
        sortField,
        setSortField,
        sortDirection,
        setSortDirection
    } = usePaginator("workers", sortFields,)

    const {data, error, isFetching} = useGetUnregisteredWorkersQuery();

    if (isFetching || !data) {
        return <CircularProgress/>
    }

    const list: Array<Tables<"unregistered_workers">> = data && data
        .filter(filterFunction(filter, ["firstName", "lastName", "partnerCode", "code"]))
        .sort(sortComparator(sortDirection, sortField)) || [];

    return <Fragment>
        <Toolbar sx={{
            display: "flex",
            "&.MuiToolbar-root": {p: 0},
            mb: 1,
            justifyContent: "space-between",
            alignItems: "flex-end",
            flexWrap: "wrap"
        }}>
            <Box sx={{display: "flex"}}>
                <SearchBox value={filter} onChange={setFilter}/>
                <SortBox sortDirection={sortDirection} sortField={sortField}
                         onChangeDirection={setSortDirection}
                         onSelectField={setSortField} fields={sortFields}
                />
            </Box>
        </Toolbar>
        {error && <SnackError error={error}/>}

        <PersonList
            list={list}
            onSelect={onSelect}/>
    </Fragment>

}


